import { Cache } from "memory-cache";
import { Client } from "../service/esiclient";
import { CorporationEntity } from ".";
import { HandleEsiError } from "../helpers/ErrorDisplayHelper";

// ESI client
const esiClient = new Client();

// Cache
const cache = new Cache();

export async function getCachedCorporationEntity(corporation_id: number): Promise<CorporationEntity | null> {
  let entity: any = await cache.get(corporation_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const corporation = await esiClient.get_corporations_corporation_id(corporation_id, null, null);
    if (corporation !== null) {
      entity = new CorporationEntity(corporation_id, corporation);
      cache.put(corporation_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    HandleEsiError(error, undefined, "corporation");
    return null;
  }
}
